exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/deep/ p-confirmdialog div{\n    z-index: 3001 !important;\n  }\n  /deep/ .ui-widget-overlay.ui-dialog-mask{\n    z-index: 1699 !important;\n  }\n\n  .loader-round-circle{\n    font-size: 6px;\n  }\n\n  @keyframes blink {\n    0%{opacity:.2}\n    20%{opacity:1}\n    100%{opacity:.2}\n  }\n  .saving{}\n  .saving span{font-size:20px;line-height:0;animation-name:blink;animation-duration:1.4s;animation-iteration-count:infinite;animation-fill-mode:both}\n  .saving span:nth-child(2){animation-delay:.2s}\n  .saving span:nth-child(3){animation-delay:.4s}\n  .example-wrap{\n    margin-bottom: 0px;\n  }\n  /* /deep/ .modal-backdrop{\n    z-index: 999;\n  }\n  /deep/ .modal{\n    z-index: 1000;\n  } */\n  ng-select{\n    background-color: #fff\n}\n:host >>> .select2-container--default{\n  width: auto !important\n} ", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/pages/admin/qrcode/batchstamp/map/map.component.css
// module id = ../../../../../src/app/pages/admin/qrcode/batchstamp/map/map.component.css
// module chunks = 3